// Modules
import React from 'react'
import { Form, Field, Formik, FormikHelpers } from 'formik'
import { TextField } from '@dasa-health/components-react'

// Application
import { maskCellPhone } from 'utils'

// Components
import { StyledForm } from './styles'
import { PhoneSchema } from 'validators/schema/PhoneValidator'
import { SignUpFooter } from 'redesign/components/molecules/SignUpFooter'

export interface CellphoneInitial {
    cellphone: string
}

interface Props {
    initialValues: CellphoneInitial
    handleSubmit: (values: CellphoneInitial, bag: FormikHelpers<CellphoneInitial>) => void
    isSubmiting: boolean
}

type Event = React.ChangeEvent<HTMLInputElement>

export const Cellphone: React.FC<Props> = ({ isSubmiting, initialValues, handleSubmit }) => {
    const handleFieldChange = (event: Event, handleChange: (e: Event) => void) => {
        event.target.value = maskCellPhone(event.target.value)
        handleChange(event)
    }

    return (
        <Formik initialValues={initialValues} onSubmit={(values, bag) => handleSubmit(values, bag)} validationSchema={PhoneSchema}>
            {({ values, touched, errors, dirty, isValid, handleChange }) => (
                <StyledForm>
                    <Form autoComplete="off" data-testid="cellphone-form">
                        <div className="form__phone">
                            <Field
                                as={TextField}
                                className="form__phone__field"
                                data-testid="cellphone-input"
                                helperText={touched.cellphone && errors.cellphone ? errors.cellphone : ''}
                                inputmode="numeric"
                                label="Celular"
                                maxLength={15}
                                name="cellphone"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFieldChange(e, handleChange)}
                                type="tel"
                                value={values.cellphone}
                                variant={touched.cellphone && errors.cellphone ? 'error' : undefined}
                            />
                        </div>
                        <SignUpFooter
                            isSubmitButtonDisabled={!isValid || !dirty}
                            isSubmitButtonLoading={isSubmiting}
                            submitButtonText="Validar"
                        />
                    </Form>
                </StyledForm>
            )}
        </Formik>
    )
}
